import { TCategory, TTopCategory } from 'data';
import { InstoreService, InstoreServiceGroup } from 'containers/instore/instore-service/types';
import { TConfigurator } from 'containers/categories-listing/types';

type TOffer = TCategory | InstoreService;

type TData = TTopCategory | InstoreServiceGroup;

export const getOffers = (data: TData[], offerType: 'categories' | 'services') => {
	const offers = data.reduce((acc, element) => {
		if (element[offerType]?.length) {
			return [...acc, ...element[offerType]];
		}
		return acc;
	}, [] as TOffer[]);

	return offers;
};

export const getOffersCount = (offers: TOffer[]) => offers.length;

export const getPrices = (offers: InstoreService[] | TCategory[] | TConfigurator[]) =>
	offers.map(offer => offer.price).filter(price => price); // фильтруем возможный null (согласно проекту) в инсторах

export const getMinPrice = (prices: number[]) => Math.min(...prices);
export const getMaxPrice = (prices: number[]) => Math.max(...prices);

export const getOfferData = (data: TData[], offerType: 'categories' | 'services') => {
	if (!data?.length) {
		return null;
	}

	const offers = getOffers(data, offerType);
	const prices = getPrices(offers);
	return {
		offerCount: getOffersCount(offers),
		lowPrice: getMinPrice(prices),
		highPrice: getMaxPrice(prices),
	};
};
